/* Beanie Boos Australia – Activity Centre
   Original artwork and simple games for kids. No external libraries.
   Each section has a root element with data-bb-activity="memory|colour|wordsearch|spot". */
(function () {
  'use strict';

  var INK = '#2E1A5C';
  var SVGNS = 'http://www.w3.org/2000/svg';

  /* ---------- Original animal artwork (viewBox 0 0 200 200) ----------
     Each shape: [tag, attrs, colour, fillable]. fillable=false keeps eyes/whiskers fixed. */
  function eyes(lx, rx, y, r) {
    return [
      ['circle', { cx: lx, cy: y, r: r }, '#FFFFFF', true],
      ['circle', { cx: rx, cy: y, r: r }, '#FFFFFF', true],
      ['circle', { cx: lx + 2, cy: y + 2, r: r * 0.5 }, INK, false],
      ['circle', { cx: rx - 2, cy: y + 2, r: r * 0.5 }, INK, false],
      ['circle', { cx: lx + 5, cy: y - 3, r: r * 0.18 }, '#FFFFFF', false],
      ['circle', { cx: rx + 1, cy: y - 3, r: r * 0.18 }, '#FFFFFF', false]
    ];
  }

  var ANIMALS = {
    owl: {
      name: 'Owl',
      shapes: [
        ['path', { d: 'M48 78 L58 30 L84 60 Z' }, '#4B8FD6', true],
        ['path', { d: 'M152 78 L142 30 L116 60 Z' }, '#4B8FD6', true],
        ['ellipse', { cx: 100, cy: 115, rx: 62, ry: 70 }, '#9AD4FF', true],
        ['ellipse', { cx: 100, cy: 138, rx: 38, ry: 42 }, '#E4F3FF', true],
        ['path', { d: 'M40 108 Q28 150 64 168 Q58 132 40 108 Z' }, '#4B8FD6', true],
        ['path', { d: 'M160 108 Q172 150 136 168 Q142 132 160 108 Z' }, '#4B8FD6', true]
      ].concat(eyes(78, 122, 92, 20)).concat([
        ['path', { d: 'M91 110 L109 110 L100 124 Z' }, '#FFD43B', true],
        ['ellipse', { cx: 82, cy: 186, rx: 13, ry: 6 }, '#FF7A1A', true],
        ['ellipse', { cx: 118, cy: 186, rx: 13, ry: 6 }, '#FF7A1A', true]
      ])
    },
    cat: {
      name: 'Cat',
      shapes: [
        ['path', { d: 'M140 172 Q186 170 178 126 Q174 116 166 124 Q170 158 134 160 Z' }, '#FF9BCB', true],
        ['ellipse', { cx: 100, cy: 160, rx: 46, ry: 34 }, '#FF9BCB', true],
        ['ellipse', { cx: 100, cy: 166, rx: 25, ry: 22 }, '#FFE3F1', true],
        ['path', { d: 'M52 80 L60 26 L94 60 Z' }, '#FF9BCB', true],
        ['path', { d: 'M148 80 L140 26 L106 60 Z' }, '#FF9BCB', true],
        ['path', { d: 'M63 66 L66 42 L83 58 Z' }, '#FFE3F1', true],
        ['path', { d: 'M137 66 L134 42 L117 58 Z' }, '#FFE3F1', true],
        ['circle', { cx: 100, cy: 95, r: 52 }, '#FF9BCB', true]
      ].concat(eyes(80, 120, 90, 15)).concat([
        ['path', { d: 'M93 110 L107 110 L100 118 Z' }, '#C2187A', true],
        ['path', { d: 'M100 118 Q94 126 86 122 M100 118 Q106 126 114 122', fill: 'none' }, null, false],
        ['path', { d: 'M60 108 L82 112 M60 120 L82 116 M140 108 L118 112 M140 120 L118 116', fill: 'none' }, null, false]
      ])
    },
    bunny: {
      name: 'Bunny',
      shapes: [
        ['ellipse', { cx: 80, cy: 48, rx: 15, ry: 40 }, '#F1E8FF', true],
        ['ellipse', { cx: 120, cy: 48, rx: 15, ry: 40 }, '#F1E8FF', true],
        ['ellipse', { cx: 80, cy: 50, rx: 7, ry: 28 }, '#FFC2DD', true],
        ['ellipse', { cx: 120, cy: 50, rx: 7, ry: 28 }, '#FFC2DD', true],
        ['ellipse', { cx: 100, cy: 166, rx: 44, ry: 30 }, '#F1E8FF', true],
        ['ellipse', { cx: 100, cy: 172, rx: 22, ry: 17 }, '#FFFFFF', true],
        ['circle', { cx: 100, cy: 108, r: 46 }, '#F1E8FF', true]
      ].concat(eyes(82, 118, 102, 13)).concat([
        ['circle', { cx: 70, cy: 122, r: 8 }, '#FFC2DD', true],
        ['circle', { cx: 130, cy: 122, r: 8 }, '#FFC2DD', true],
        ['ellipse', { cx: 100, cy: 120, rx: 6, ry: 4 }, '#FF5FA8', true],
        ['path', { d: 'M100 124 Q95 131 89 128 M100 124 Q105 131 111 128', fill: 'none' }, null, false]
      ])
    },
    bear: {
      name: 'Bear',
      shapes: [
        ['circle', { cx: 60, cy: 58, r: 19 }, '#C68B59', true],
        ['circle', { cx: 140, cy: 58, r: 19 }, '#C68B59', true],
        ['circle', { cx: 60, cy: 58, r: 9 }, '#F2CFA5', true],
        ['circle', { cx: 140, cy: 58, r: 9 }, '#F2CFA5', true],
        ['ellipse', { cx: 100, cy: 166, rx: 46, ry: 32 }, '#C68B59', true],
        ['ellipse', { cx: 100, cy: 170, rx: 24, ry: 20 }, '#F2CFA5', true],
        ['circle', { cx: 100, cy: 100, r: 50 }, '#C68B59', true]
      ].concat(eyes(80, 120, 92, 12)).concat([
        ['ellipse', { cx: 100, cy: 120, rx: 23, ry: 17 }, '#F2CFA5', true],
        ['ellipse', { cx: 100, cy: 113, rx: 8, ry: 6 }, INK, false],
        ['path', { d: 'M100 119 L100 126 Q94 132 88 128 M100 126 Q106 132 112 128', fill: 'none' }, null, false]
      ])
    },
    penguin: {
      name: 'Penguin',
      shapes: [
        ['path', { d: 'M44 110 Q26 140 50 166 Q52 136 58 118 Z' }, '#2E1A5C', true],
        ['path', { d: 'M156 110 Q174 140 150 166 Q148 136 142 118 Z' }, '#2E1A5C', true],
        ['ellipse', { cx: 100, cy: 112, rx: 56, ry: 76 }, '#4B2A8C', true],
        ['ellipse', { cx: 100, cy: 126, rx: 40, ry: 58 }, '#FFFFFF', true]
      ].concat(eyes(84, 116, 90, 11)).concat([
        ['path', { d: 'M90 104 L110 104 L100 116 Z' }, '#FF7A1A', true],
        ['circle', { cx: 72, cy: 110, r: 7 }, '#FFC2DD', true],
        ['circle', { cx: 128, cy: 110, r: 7 }, '#FFC2DD', true],
        ['ellipse', { cx: 84, cy: 188, rx: 14, ry: 6 }, '#FF7A1A', true],
        ['ellipse', { cx: 116, cy: 188, rx: 14, ry: 6 }, '#FF7A1A', true]
      ])
    },
    frog: {
      name: 'Frog',
      shapes: [
        ['circle', { cx: 68, cy: 84, r: 24 }, '#7FE3D0', true],
        ['circle', { cx: 132, cy: 84, r: 24 }, '#7FE3D0', true],
        ['ellipse', { cx: 100, cy: 138, rx: 66, ry: 48 }, '#7FE3D0', true],
        ['ellipse', { cx: 100, cy: 156, rx: 40, ry: 26 }, '#DDF8F2', true]
      ].concat(eyes(68, 132, 84, 15)).concat([
        ['path', { d: 'M78 124 Q100 140 122 124', fill: 'none' }, null, false],
        ['circle', { cx: 60, cy: 124, r: 8 }, '#FFC2DD', true],
        ['circle', { cx: 140, cy: 124, r: 8 }, '#FFC2DD', true],
        ['ellipse', { cx: 62, cy: 182, rx: 20, ry: 8 }, '#4FC4AE', true],
        ['ellipse', { cx: 138, cy: 182, rx: 20, ry: 8 }, '#4FC4AE', true]
      ])
    }
  };
  var ANIMAL_KEYS = ['owl', 'cat', 'bunny', 'bear', 'penguin', 'frog'];

  function el(tag, attrs) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]);
    return n;
  }

  /* mode 'colour' = full colour; 'outline' = white fills for colouring in */
  function drawAnimal(key, mode, label) {
    var a = ANIMALS[key];
    var svg = el('svg', { viewBox: '0 0 200 200', role: 'img', 'aria-label': label || a.name });
    a.shapes.forEach(function (s, i) {
      var attrs = {};
      for (var k in s[1]) attrs[k] = s[1][k];
      var isLine = s[2] === null;
      attrs.stroke = INK;
      attrs['stroke-width'] = isLine ? 3 : (mode === 'outline' ? 3 : 2.5);
      attrs['stroke-linecap'] = 'round';
      attrs['stroke-linejoin'] = 'round';
      if (!isLine) {
        attrs.fill = (mode === 'outline' && s[3]) ? '#FFFFFF' : s[2];
        if (mode === 'outline' && !s[3]) attrs.fill = s[2];
      }
      var node = el(s[0], attrs);
      if (mode === 'outline' && s[3]) {
        node.setAttribute('data-region', String(i));
      }
      svg.appendChild(node);
    });
    return svg;
  }

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function announce(root, msg) {
    var live = root.querySelector('[data-bb-live]');
    if (live) live.textContent = msg;
  }

  /* ---------- Memory match ---------- */
  function initMemory(root) {
    var board = root.querySelector('[data-bb-board]');
    var movesEl = root.querySelector('[data-bb-moves]');
    var winEl = root.querySelector('[data-bb-win]');
    var resetBtn = root.querySelector('[data-bb-reset]');
    var pairs = Math.min(parseInt(root.getAttribute('data-pairs'), 10) || 6, ANIMAL_KEYS.length);
    var first = null, lock = false, moves = 0, matched = 0;

    function setMoves() { if (movesEl) movesEl.textContent = String(moves); }

    function build() {
      board.textContent = '';
      first = null; lock = false; moves = 0; matched = 0; setMoves();
      if (winEl) winEl.hidden = true;
      var keys = shuffle(ANIMAL_KEYS.slice()).slice(0, pairs);
      var deck = shuffle(keys.concat(keys));
      deck.forEach(function (key, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bb-mem__card';
        btn.setAttribute('aria-label', 'Card ' + (idx + 1) + ', face down');
        btn.dataset.key = key;
        var inner = document.createElement('span');
        inner.className = 'bb-mem__inner';
        var back = document.createElement('span');
        back.className = 'bb-mem__face bb-mem__back';
        back.setAttribute('aria-hidden', 'true');
        back.innerHTML = '<svg viewBox="0 0 24 24" width="38" height="38" aria-hidden="true"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" fill="#FFD43B"/></svg>';
        var front = document.createElement('span');
        front.className = 'bb-mem__face bb-mem__front';
        front.setAttribute('aria-hidden', 'true');
        front.appendChild(drawAnimal(key, 'colour'));
        inner.appendChild(back); inner.appendChild(front);
        btn.appendChild(inner);
        btn.addEventListener('click', function () { flip(btn, idx); });
        board.appendChild(btn);
      });
    }

    function flip(btn, idx) {
      if (lock || btn.classList.contains('is-flipped')) return;
      btn.classList.add('is-flipped');
      btn.setAttribute('aria-label', 'Card ' + (idx + 1) + ', ' + ANIMALS[btn.dataset.key].name);
      if (!first) { first = btn; return; }
      moves++; setMoves();
      var second = btn;
      if (first.dataset.key === second.dataset.key) {
        first.classList.add('is-matched'); second.classList.add('is-matched');
        first.disabled = true; second.disabled = true;
        announce(root, 'Match! ' + ANIMALS[btn.dataset.key].name);
        first = null; matched++;
        if (matched === pairs) {
          if (winEl) winEl.hidden = false;
          announce(root, 'You found all the pairs in ' + moves + ' turns!');
        }
      } else {
        lock = true;
        var a = first; first = null;
        setTimeout(function () {
          [a, second].forEach(function (c) {
            c.classList.remove('is-flipped');
            c.setAttribute('aria-label', c.getAttribute('aria-label').replace(/, \w+$/, ', face down'));
          });
          lock = false;
        }, 900);
      }
    }

    if (resetBtn) resetBtn.addEventListener('click', build);
    build();
  }

  /* ---------- Colour in ---------- */
  var PALETTE = [
    ['#FF5FA8', 'Pink'], ['#C2187A', 'Magenta'], ['#FF7A1A', 'Orange'], ['#FFD43B', 'Yellow'],
    ['#7FE3D0', 'Mint'], ['#3BB273', 'Green'], ['#9AD4FF', 'Sky blue'], ['#4B8FD6', 'Blue'],
    ['#9B6BE8', 'Purple'], ['#C68B59', 'Brown'], ['#8A8A8A', 'Grey'], ['#FFFFFF', 'White']
  ];

  function initColour(root) {
    var stage = root.querySelector('[data-bb-stage]');
    var paletteEl = root.querySelector('[data-bb-palette]');
    var picker = root.querySelector('[data-bb-picker]');
    var current = PALETTE[0][0];
    var svg;

    PALETTE.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bb-col__swatch';
      b.style.background = p[0];
      b.setAttribute('aria-label', p[1]);
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        current = p[0];
        paletteEl.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
      });
      paletteEl.appendChild(b);
    });

    function load(key) {
      stage.textContent = '';
      svg = drawAnimal(key, 'outline', ANIMALS[key].name + ' colouring picture');
      // simple scenery
      var bg = [
        ['circle', { cx: 24, cy: 24, r: 14 }],
        ['path', { d: 'M176 18 l3 9 9 3 -9 3 -3 9 -3 -9 -9 -3 9 -3z' }],
        ['path', { d: 'M18 150 l2.5 7 7 2.5 -7 2.5 -2.5 7 -2.5 -7 -7 -2.5 7 -2.5z' }]
      ];
      bg.forEach(function (s, i) {
        var attrs = s[1]; attrs.fill = '#FFFFFF'; attrs.stroke = INK; attrs['stroke-width'] = 3; attrs['stroke-linejoin'] = 'round';
        var n = el(s[0], attrs); n.setAttribute('data-region', 'bg' + i);
        svg.insertBefore(n, svg.firstChild);
      });
      svg.querySelectorAll('[data-region]').forEach(function (r) {
        r.setAttribute('tabindex', '0');
        r.setAttribute('role', 'button');
        r.setAttribute('aria-label', 'Colour this part');
        r.addEventListener('click', function () { r.setAttribute('fill', current); });
        r.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); r.setAttribute('fill', current); }
        });
      });
      stage.appendChild(svg);
    }

    picker.querySelectorAll('button[data-animal]').forEach(function (b) {
      b.addEventListener('click', function () {
        picker.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        load(b.getAttribute('data-animal'));
      });
    });

    root.querySelector('[data-bb-clear]').addEventListener('click', function () {
      svg.querySelectorAll('[data-region]').forEach(function (r) { r.setAttribute('fill', '#FFFFFF'); });
    });

    function svgString() {
      var clone = svg.cloneNode(true);
      clone.setAttribute('xmlns', SVGNS);
      clone.setAttribute('width', '800'); clone.setAttribute('height', '800');
      return new XMLSerializer().serializeToString(clone);
    }

    root.querySelector('[data-bb-save]').addEventListener('click', function () {
      var img = new Image();
      img.onload = function () {
        var c = document.createElement('canvas'); c.width = 800; c.height = 800;
        var ctx = c.getContext('2d'); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, 800, 800);
        ctx.drawImage(img, 0, 0, 800, 800);
        var a = document.createElement('a');
        a.download = 'my-colouring.png';
        a.href = c.toDataURL('image/png');
        document.body.appendChild(a); a.click(); a.remove();
      };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString());
    });

    root.querySelector('[data-bb-print]').addEventListener('click', function () {
      printHtml('Colouring page', '<div style="text-align:center"><h1>' + escapeHtml(root.getAttribute('data-print-title') || 'Colour me in!') + '</h1><div style="width:600px;max-width:100%;margin:0 auto">' + svgString() + '</div></div>');
    });

    var firstBtn = picker.querySelector('button[data-animal]');
    firstBtn.setAttribute('aria-pressed', 'true');
    load(firstBtn.getAttribute('data-animal'));
  }

  /* ---------- Word search ---------- */
  function initWordSearch(root) {
    var gridEl = root.querySelector('[data-bb-grid]');
    var listEl = root.querySelector('[data-bb-words]');
    var winEl = root.querySelector('[data-bb-win]');
    var size = Math.max(6, Math.min(12, parseInt(root.getAttribute('data-size'), 10) || 8));
    var raw = (root.getAttribute('data-words') || '').toUpperCase().split(',');
    var words = raw.map(function (w) { return w.replace(/[^A-Z]/g, ''); })
      .filter(function (w) { return w.length >= 2 && w.length <= size; }).slice(0, 10);
    var grid, placed, start, found;
    var ABC = 'ABCDEFGHIJKLMNOPRSTUWY';

    function tryPlace(word) {
      for (var attempt = 0; attempt < 200; attempt++) {
        var dir = Math.random() < 0.5 ? [0, 1] : [1, 0]; // across or down only (easier for kids)
        var r = Math.floor(Math.random() * (size - dir[0] * (word.length - 1)));
        var c = Math.floor(Math.random() * (size - dir[1] * (word.length - 1)));
        var ok = true;
        for (var i = 0; i < word.length; i++) {
          var ch = grid[r + dir[0] * i][c + dir[1] * i];
          if (ch && ch !== word[i]) { ok = false; break; }
        }
        if (!ok) continue;
        var cells = [];
        for (var j = 0; j < word.length; j++) {
          grid[r + dir[0] * j][c + dir[1] * j] = word[j];
          cells.push((r + dir[0] * j) * size + (c + dir[1] * j));
        }
        return cells;
      }
      return null;
    }

    function build() {
      grid = []; placed = []; start = null; found = 0;
      for (var r = 0; r < size; r++) { grid.push([]); for (var c = 0; c < size; c++) grid[r].push(''); }
      words.slice().sort(function (a, b) { return b.length - a.length; }).forEach(function (w) {
        var cells = tryPlace(w);
        if (cells) placed.push({ word: w, cells: cells, found: false });
      });
      for (var r2 = 0; r2 < size; r2++) for (var c2 = 0; c2 < size; c2++) {
        if (!grid[r2][c2]) grid[r2][c2] = ABC[Math.floor(Math.random() * ABC.length)];
      }
      render();
    }

    function render() {
      gridEl.textContent = '';
      gridEl.style.gridTemplateColumns = 'repeat(' + size + ', minmax(0, 1fr))';
      for (var r = 0; r < size; r++) for (var c = 0; c < size; c++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bb-ws__cell';
        b.textContent = grid[r][c];
        b.dataset.i = String(r * size + c);
        b.setAttribute('aria-label', grid[r][c] + ', row ' + (r + 1) + ', column ' + (c + 1));
        b.addEventListener('click', onCell);
        gridEl.appendChild(b);
      }
      listEl.textContent = '';
      placed.slice().sort(function (a, b) { return a.word < b.word ? -1 : 1; }).forEach(function (p) {
        var li = document.createElement('li');
        li.textContent = p.word; li.dataset.word = p.word;
        listEl.appendChild(li);
      });
      if (winEl) winEl.hidden = true;
    }

    function onCell(e) {
      var b = e.currentTarget, i = parseInt(b.dataset.i, 10);
      if (start === null) { start = i; b.classList.add('is-start'); return; }
      var s = start; start = null;
      gridEl.querySelectorAll('.is-start').forEach(function (x) { x.classList.remove('is-start'); });
      placed.forEach(function (p) {
        if (p.found) return;
        var a = p.cells[0], z = p.cells[p.cells.length - 1];
        if ((s === a && i === z) || (s === z && i === a)) {
          p.found = true; found++;
          p.cells.forEach(function (ci) { gridEl.children[ci].classList.add('is-found'); });
          var li = listEl.querySelector('[data-word="' + p.word + '"]');
          if (li) li.classList.add('is-found');
          announce(root, 'Found ' + p.word + '!');
          if (found === placed.length && winEl) { winEl.hidden = false; announce(root, 'You found every word!'); }
        }
      });
    }

    root.querySelector('[data-bb-new]').addEventListener('click', build);
    root.querySelector('[data-bb-print]').addEventListener('click', function () {
      var rows = '';
      for (var r = 0; r < size; r++) {
        rows += '<tr>';
        for (var c = 0; c < size; c++) rows += '<td>' + grid[r][c] + '</td>';
        rows += '</tr>';
      }
      var list = placed.map(function (p) { return '<li>' + p.word + '</li>'; }).join('');
      printHtml('Word search', '<h1>' + escapeHtml(root.getAttribute('data-print-title') || 'Word search') + '</h1>' +
        '<table class="ws">' + rows + '</table><h2>Find these words</h2><ul class="wl">' + list + '</ul>');
    });
    build();
  }

  /* ---------- Spot the difference ---------- */
  function scene(changed) {
    var svg = el('svg', { viewBox: '0 0 300 220', role: 'img', 'aria-label': changed ? 'Picture B' : 'Picture A' });
    function add(tag, attrs) {
      attrs.stroke = INK; attrs['stroke-width'] = attrs['stroke-width'] || 2.5; attrs['stroke-linejoin'] = 'round';
      svg.appendChild(el(tag, attrs));
    }
    add('rect', { x: 0, y: 0, width: 300, height: 220, fill: '#E4F3FF', 'stroke-width': 0 });
    add('rect', { x: 0, y: 160, width: 300, height: 60, fill: '#B6EBC7', 'stroke-width': 0 });
    add('circle', { cx: 252, cy: 40, r: 22, fill: changed ? '#FF7A1A' : '#FFD43B' });               // 1 sun colour
    add('path', { d: 'M30 50 q10 -18 28 -8 q14 -12 26 4 q16 2 10 16 h-58 q-14 -4 -6 -12z', fill: '#FFFFFF' });
    if (!changed) add('path', { d: 'M150 34 q8 -14 22 -6 q12 -8 20 4 q12 2 8 12 h-46 q-10 -4 -4 -10z', fill: '#FFFFFF' }); // 2 cloud missing
    add('rect', { x: 40, y: 110, width: 12, height: 56, fill: '#C68B59' });
    add('circle', { cx: 46, cy: 98, r: 30, fill: '#3BB273' });
    // flowers
    [[110, 178, '#FF5FA8'], [140, 186, changed ? '#9B6BE8' : '#FF5FA8'], [262, 180, '#FFD43B']].forEach(function (f) { // 3 flower colour
      add('path', { d: 'M' + f[0] + ' ' + (f[1] + 4) + ' v16', fill: 'none' });
      add('circle', { cx: f[0], cy: f[1], r: 7, fill: f[2] });
    });
    // bunny friend (simplified)
    add('ellipse', { cx: 198, cy: 108, rx: 8, ry: 22, fill: '#F1E8FF' });
    if (!changed) add('ellipse', { cx: 222, cy: 108, rx: 8, ry: 22, fill: '#F1E8FF' });                 // 4 missing ear
    add('ellipse', { cx: 210, cy: 176, rx: 28, ry: 20, fill: '#F1E8FF' });
    add('circle', { cx: 210, cy: 140, r: 26, fill: '#F1E8FF' });
    add('circle', { cx: 201, cy: 136, r: 4, fill: INK, 'stroke-width': 0 });
    add('circle', { cx: 219, cy: 136, r: 4, fill: INK, 'stroke-width': 0 });
    add('ellipse', { cx: 210, cy: 147, rx: 4, ry: 3, fill: '#FF5FA8' });
    if (changed) add('path', { d: 'M86 120 l3 9 9 3 -9 3 -3 9 -3 -9 -9 -3 9 -3z', fill: '#FFD43B' });   // 5 extra star
    return svg;
  }
  var DIFFS = [
    { x: 252, y: 40, r: 30, label: 'The sun' },
    { x: 174, y: 32, r: 30, label: 'A cloud' },
    { x: 140, y: 186, r: 16, label: 'A flower' },
    { x: 222, y: 104, r: 26, label: 'An ear' },
    { x: 86, y: 132, r: 20, label: 'A star' }
  ];

  function initSpot(root) {
    var a = root.querySelector('[data-bb-pic-a]');
    var b = root.querySelector('[data-bb-pic-b]');
    var countEl = root.querySelector('[data-bb-count]');
    var winEl = root.querySelector('[data-bb-win]');
    var found;

    function mark(svg, d) {
      svg.appendChild(el('circle', { cx: d.x, cy: d.y, r: d.r, fill: 'none', stroke: '#C2187A', 'stroke-width': 4, 'class': 'bb-spot__ring' }));
    }

    function build() {
      found = {};
      a.textContent = ''; b.textContent = '';
      var sa = scene(false), sb = scene(true);
      a.appendChild(sa); b.appendChild(sb);
      [sa, sb].forEach(function (svg) {
        svg.addEventListener('click', function (e) {
          var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
          var p = pt.matrixTransform(svg.getScreenCTM().inverse());
          DIFFS.forEach(function (d, i) {
            if (found[i]) return;
            var dx = p.x - d.x, dy = p.y - d.y;
            if (dx * dx + dy * dy <= d.r * d.r) {
              found[i] = true; mark(sa, d); mark(sb, d);
              var n = Object.keys(found).length;
              countEl.textContent = String(n);
              announce(root, d.label + ' is different! ' + n + ' of ' + DIFFS.length + ' found.');
              if (n === DIFFS.length && winEl) winEl.hidden = false;
            }
          });
        });
      });
      countEl.textContent = '0';
      if (winEl) winEl.hidden = true;
    }

    root.querySelector('[data-bb-hint]').addEventListener('click', function () {
      for (var i = 0; i < DIFFS.length; i++) {
        if (!found[i]) {
          var svgB = b.querySelector('svg');
          var h = el('circle', { cx: DIFFS[i].x, cy: DIFFS[i].y, r: DIFFS[i].r, fill: 'rgba(255,212,59,0.35)', stroke: 'none', 'class': 'bb-spot__hint' });
          svgB.appendChild(h);
          setTimeout(function () { h.remove(); }, 1500);
          announce(root, 'Look near: ' + DIFFS[i].label.toLowerCase());
          return;
        }
      }
    });
    root.querySelector('[data-bb-reset]').addEventListener('click', build);
    build();
  }

  /* ---------- Shared ---------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function printHtml(title, body) {
    var w = window.open('', '_blank', 'width=800,height=900');
    if (!w) { alert('Please allow pop-ups to print this activity.'); return; }
    w.document.write('<!doctype html><html><head><meta charset="utf-8"><title>' + escapeHtml(title) +
      '</title><style>body{font-family:Arial,sans-serif;color:#2E1A5C;margin:32px;text-align:center}' +
      'h1{font-size:32px;margin:0 0 20px}h2{font-size:22px;margin:28px 0 10px}' +
      'table.ws{border-collapse:collapse;margin:0 auto}table.ws td{width:44px;height:44px;border:1px solid #999;font-size:24px;font-weight:bold;text-align:center}' +
      'ul.wl{list-style:none;padding:0;display:flex;flex-wrap:wrap;gap:12px 28px;justify-content:center;font-size:20px;font-weight:bold}' +
      'svg{width:100%;height:auto}.foot{margin-top:28px;font-size:12px;color:#666}</style></head><body>' +
      body + '<p class="foot">beanieboosaustralia.com</p></body></html>');
    w.document.close();
    w.focus();
    setTimeout(function () { w.print(); }, 300);
  }

  var INIT = { memory: initMemory, colour: initColour, wordsearch: initWordSearch, spot: initSpot };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bb-activity]').forEach(function (root) {
      if (root.dataset.bbReady) return;
      var fn = INIT[root.getAttribute('data-bb-activity')];
      if (fn) { root.dataset.bbReady = '1'; fn(root); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
